import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import t from "common/i18n";
import Slider from "@cld/slider";
import { secondsToMinutes } from "../../utils";
import { useFilterParams } from "../../selectors";
import { DURATION_MIN, DURATION_MAX, DURATION_STEP, DURATION_INITIAL_VALUE } from "../../filterConsts";
import { SectionBox } from "./Filters.styles";

const DurationBox = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top: ${globalTheme.spacing.xxs};

`;

const DurationSectionBox = styled(SectionBox)`
	z-index: 1;
`;

export default ({ handleSearch, source }) => {
	const { duration } = useFilterParams(source);
	const [localDuration, setLocalDuration] = useState(duration ?? DURATION_INITIAL_VALUE);

	const filterChange = useCallback((value) => {
		handleSearch({
			filters: {
				duration: value
			}
		});
	}, [handleSearch]);

	return (<DurationSectionBox data-test="duration-section">
		<label>{t(`${source}.filters.duration.label`)}</label>
		<Slider.Normal
			value={localDuration}
			min={DURATION_MIN}
			max={DURATION_MAX}
			step={DURATION_STEP}
			pearling
			onChange={setLocalDuration}
			onAfterChange={filterChange}
		/>
		<DurationBox>
			<label>{secondsToMinutes(localDuration[0])}</label>
			<label>{secondsToMinutes(localDuration[1])}</label>
		</DurationBox>
	</DurationSectionBox>);
};

